import PropTypes from 'prop-types';
import React from 'react';
import CompanyDetailsForm from './CompanyDetailsForm';
import Container from '../../ui/Container';
import Footer from '../../ui/Footer';
import LarsImage from '../../ui/LarsImage';
import Layout from '../../ui/Layout';
import SectionWrap from '../../ui/SectionWrap';
import styled from 'styled-components';
import { RIGHT_FACING_ARROW } from '../../ui/SVGIcon';
import { useForm, FormProvider } from 'react-hook-form';
import Header from '../../ui/Header';

const Form = styled.form`
  all: unset;
`;

const CompanyDetails = ({
  client,
  isMaintenanceModeActive,
  handleCompanyDetailsSubmit,
  isLoading,
  history,
  hasTopBanner,
}) => {
  const methods = useForm();
  const { handleSubmit } = methods;

  const onSubmit = payload => {
    handleCompanyDetailsSubmit({
      client,
      payload,
      redirect: history.push,
    });
  };

  const createPayload = ({ numberOfEmployees, monthlyRevenue, lastYearTaxesFiled }) => ({
    numberOfEmployees: numberOfEmployees?.value,
    monthlyRevenue: monthlyRevenue?.value,
    lastYearTaxesFiled: lastYearTaxesFiled?.value,
  });

  return (
    <FormProvider {...methods}>
      <Form
        name="lastpass-disable-search"
        onSubmit={handleSubmit(fieldValues => onSubmit(createPayload(fieldValues)))}
      >
        <Layout>
          <Layout.Sidebar>
            <LarsImage />
          </Layout.Sidebar>
          <Layout.Page hasSidebar hasTopBanner={hasTopBanner}>
            <SectionWrap>
              <Container minWidth="580px" topPadding="32px">
                <Header
                  headerText="Tell us about your business"
                  subHeaderText="We’d like to learn more about your business so that we can provide you with the best experience possible."
                />
                <CompanyDetailsForm isLoading={isLoading} client={client} />
              </Container>
            </SectionWrap>
          </Layout.Page>
          <Layout.Footer hasSidebar>
            <Footer
              hasNext
              icon={RIGHT_FACING_ARROW}
              isLoading={isLoading}
              onClickNext={handleSubmit}
              text={isMaintenanceModeActive ? 'Finish Signing Up' : 'Next'}
            />
          </Layout.Footer>
        </Layout>
      </Form>
    </FormProvider>
  );
};

export default CompanyDetails;

CompanyDetails.propTypes = {
  isLoading: PropTypes.bool,
  client: PropTypes.object.isRequired,
  handleCompanyDetailsSubmit: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  isMaintenanceModeActive: PropTypes.bool,
  hasTopBanner: PropTypes.bool.isRequired,
};

CompanyDetails.defaultProps = {
  isMaintenanceModeActive: false,
  isLoading: false,
};
